enum PassiveIncomeFromGatheringVillagerModifierId {
    ENCLOSURES = 'ENCLOSURES',
    TEMPLAR_KNIGHT_FOOD_FROM_WOOD_DARK_AGE = 'TEMPLAR_KNIGHT_FOOD_FROM_WOOD_DARK_AGE',
    TEMPLAR_KNIGHT_FOOD_FROM_WOOD_FEUDAL_AGE = 'TEMPLAR_KNIGHT_FOOD_FROM_WOOD_FEUDAL_AGE',
    TEMPLAR_KNIGHT_FOOD_FROM_WOOD_CASTLE_AGE = 'TEMPLAR_KNIGHT_FOOD_FROM_WOOD_CASTLE_AGE',
    TEMPLAR_KNIGHT_FOOD_FROM_WOOD_IMPERIAL_AGE = 'TEMPLAR_KNIGHT_FOOD_FROM_WOOD_IMPERIAL_AGE',
}

export default PassiveIncomeFromGatheringVillagerModifierId;